<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<div [ngClass]="{'show': !isExts, 'hide': isExts}" appLifecycleTracker trackerName="import-exts-folders-dialog">
    <h1 class="header">{{fHeaderA}}</h1>
    <p>{{fAPA}}</p>
    <p>{{fAPB}}</p>
    <p>{{fAPC}}&nbsp;<b>{{'NONE' | translate}}</b>,&nbsp;<b>Dynamic</b>,&nbsp;{{fAPG}}&nbsp;<b>Always On</b>.</p>
    <p>{{fAPJ}}&nbsp;<b>{{'NONE' | translate}}</b>&nbsp;{{fAPG}}<b>&nbsp;{{fAPK}}</b>.</p>
    <p>{{fAPL}}</p>
</div>
<div [ngClass]="{'show': isExts, 'hide': !isExts}">
    <h1 class="header">{{fHeaderB}}</h1>
    <p>{{fAPA}}</p>
    <p>{{fBPA}}</p>
    <p>{{fAPC}}&nbsp;<b>{{'NONE' | translate}}</b>&nbsp;{{fBPB}}&nbsp;<b>Always On</b>.&nbsp;{{fAPL}}</p>
</div>
<input type="file" #fileDropRef id="fileDropRef" accept=".csv" (change)="fileBrowseHandler($event.target.files)" />
<div class="button-wrapper">
    <button mat-raised-button color="primary" (click)="submit()" style="float: right;" >{{fSubmit}}</button>
    <button mat-raised-button (click)="cancel()" style="float: right;" >{{fCancel}}</button>
</div>
